export default "__VITE_ASSET__CXOhdyGx__"